import axios from 'axios';
import urlJoin from 'url-join';

import { getSearchParamsAsObject } from './Referrer';
import { HABITATION_VALUATION_URL } from 'constants/Global';

/**
 * Redirect to login page with next URL parameter
 */
export const redirectToLogin = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('token');
    const nextUrl = encodeURIComponent(url.pathname + url.search);
    const loginUrl = urlJoin(MA.Config.WWW_URL, `/mon-compte/connexion?next=${nextUrl}`);
    window.location.assign(loginUrl);
};

/**
 * Generate an habitation valuation URL in MyAccount
 * @param {String|number} [habitationId]
 * @returns {String}
 */
export const getHabitationValuationUrl = (habitationId) => {
    return urlJoin(
        MA.Config.WWW_URL,
        HABITATION_VALUATION_URL,
        habitationId ? String(habitationId) : '',
    );
};

/**
 * Redirect to an habitation valuation URL in MyAccount with offline token when needed
 * @param {String|number} [habitationId]
 * @returns {String}
 */
export const redirectToHabitationValuation = (habitationId) => {
    let params = [];
    let habitationValuationUrl = getHabitationValuationUrl(habitationId);

    if (isOfflineWithToken()) {
        const { token } = getSearchParamsAsObject();
        params.push(`token=${token}`);
    }

    habitationValuationUrl += params.length ? `?${params.join('&')}` : '';
    window.location.assign(habitationValuationUrl);
};

/**
 * Return axios headers with an auth token if necessary
 * @returns {{"X-MA-TOKEN": *}|{}}
 */
export const addTokenToHeaders = (headers = {}) => {
    const { token } = getSearchParamsAsObject();

    return {
        ...(!token ? {} : { 'X-MA-TOKEN': token }),
        ...headers,
    };
};

/**
 * Check is the user is disconnected & has an estima token from barometre's email
 * @return boolean
 */
export const isOfflineWithToken = () => {
    const { token } = getSearchParamsAsObject();
    return !!token && Object.entries(window.user).length === 0;
};

/**
 * Add estima's data to window
 * @returns {Promise<void>}
 */
export const feedEstima = async (estima_id, axiosOptions) => {
    const { data } = await axios.get(urlJoin(MA.Config.API_URL, estima_id), axiosOptions);

    window.estima = data;
};

/**
 * Add result from /datalayer to window
 * @returns {Promise<void>}
 */
export const feedWindow = async () => {
    const { data } = await axios.get(urlJoin(MA.Config.WWW_URL, '/datalayer'));

    Object.assign(window, {
        realtor: data.realtor,
        user: data.user,
        csrfToken: data.csrf_token,
        analyticsUser: data.analytics_user,
        dispatchers: data.list_dispatcher,
    });
};

/**
 * If user does not match with token then we log him out
 * @returns {Promise<void>}
 */
export const checkSession = async (axiosOptions) => {
    try {
        await axios.get(urlJoin(MA.Config.WWW_URL, '/contact/token/validate'), axiosOptions);
    } catch (e) {
        if (e?.response?.status === 400) {
            window.location.assign(urlJoin(MA.Config.WWW_URL, '/signout'));
        }
    }
};

export const initEstima = async () => {
    const { estima_id, token } = getSearchParamsAsObject();
    const axiosOptions = { headers: addTokenToHeaders() };
    const isBarometre = window?.location?.pathname?.includes('update');

    if (token) await checkSession(axiosOptions);
    await feedWindow();
    if (isBarometre) {
        try {
            await feedEstima(estima_id, axiosOptions);
        } catch (e) {
            if (
                e?.response?.status === 400 ||
                e?.response?.status === 401 ||
                e?.response?.status === 403
            ) {
                redirectToLogin();
            }
        }
    }
};
